export const getMostActiveState = (activeStateMapper) => {
  const countMapper = {};
  let mostActiveState: string | null = activeStateMapper[Object.keys(activeStateMapper)[0]];

  if (mostActiveState === undefined) {
    return null;
  }

  Object.keys(activeStateMapper).forEach(state => {
    if (countMapper[activeStateMapper[state]]) {
      countMapper[activeStateMapper[state]]++;
    } else {
      countMapper[activeStateMapper[state]] = 1;
    }

    if (mostActiveState !== null && (countMapper[activeStateMapper[state]] > countMapper[mostActiveState])) {
      mostActiveState = activeStateMapper[state];
    }
  });

  return mostActiveState;
};
